<template>
<div>
<v-app>
<resizable-page>
  <template v-slot:table="tableProps">
  <v-card>
    <!-- <v-card-title>
      Driver List
    </v-card-title> -->
    <v-card-title>
      
        <v-menu
        :key="componentKeyMenuRange"
        ref="menu_range"
        v-model="menu_range"
        :close-on-content-click="false"
        :return-value.sync="date_range_list"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="auto"
        :disabled="!active_header"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="date_range_list_show"
            label="Date Range"
            prepend-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
            class="shrink"
          ></v-text-field>
        </template>
        <v-date-picker 
          v-model="date_range_list"
          range
          no-title
          scrollable
          show-adjacent-months
          :show-current="date_list"
        >
          <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            @click="menu_range = false"
          >
            Cancel
          </v-btn>
          <v-btn
            text
            color="primary"
            @click="$refs.menu_range.save(date_range_list);changeDateRange();"
          >
            OK
          </v-btn>
        </v-date-picker>
      </v-menu>
        <v-menu 
        :disabled="!active_header">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="primary"
            dark
            class="ma-2"
            v-bind="attrs"
            v-on="on"
          >
            Export To XLS
          </v-btn>
        </template>
        <v-list>
          <v-list-item>
            <downloadExcel
                    :data="dataExport(table)"
                    :fields="field_export"
                    :worksheet="worksheetName"
                    :name="fileName"
                  >
                    All Record
             </downloadExcel>
          </v-list-item>
          <v-list-item>
            <downloadExcel
                    :data="exportDisplayedPage"
                    :fields="field_export"
                    :worksheet="worksheetName"
                    :name="fileName"
                  >
                    Displayed record
             </downloadExcel>
          </v-list-item>
          <v-list-item>
            <downloadExcel
                    :data="exportAllFitered"
                    :fields="field_export"
                    :worksheet="worksheetName"
                    :name="fileName"
                  >
                    All filtered record
                  </downloadExcel>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      
      <v-text-field
      
        :disabled="!active_header"
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>

   <v-card-title>
     <div class="d-flex">

      <v-text-field
        v-model="vehicle_chassis_no"
        label="Chassis No."
         class="shrink"
      >
      </v-text-field>
        <v-btn  class="mt-5" :disabled="!vehicle_chassis_no"  small color="primary" @click="findVehicleChassisNo"> <v-icon>mdi-magnify</v-icon> </v-btn>
    </div>
     <v-spacer></v-spacer>
     <div class="d-flex">

      <v-text-field
        v-model="vehicle_door_no"
        label="Vehicle No."
         class="shrink"
      >
      </v-text-field>
        <v-btn  class="mt-5" :disabled="!vehicle_door_no" small color="primary" @click="findVehicleDoorNo"> <v-icon>mdi-magnify</v-icon> </v-btn>
    </div>
      <v-spacer></v-spacer>
      <div class="d-flex">

      <v-text-field
        v-model="vehicle_plate_no"
        label="Plat No."
         class="shrink"
      >
      </v-text-field>
        <v-btn  class="mt-5" :disabled="!vehicle_plate_no" small color="primary" @click="findVehiclePlatNo"> <v-icon>mdi-magnify</v-icon> </v-btn>
    </div>
     </v-card-title>

    <v-data-table
      mobile-breakpoint
      :headers="headers"
      :items="table"
      :search="search"
      :loading="loadTable"
      loading-text="Loading... Please wait"
      @current-items="getFiltered"
      ref="vTable"
      :height="tableProps.tableHeight"
      fixed-header
      :footer-props="{'items-per-page-options':[5,15, 30, 50, 100]}"
      :options="{'itemsPerPage':50}"
      single-expand
      show-expand
    >
<template v-slot:[`item.spare_part_master_code_name`]="{ item }">
      {{item.spare_part_master_code+' - '+item.spare_part_master_name}}
     </template>
   
     <template v-slot:[`item.pkb_spare_part_price`]="{ item }">
      <span style="float: left; ">Rp.</span><span style="float:right;">{{
                formatPrice(item.pkb_spare_part_price)
              }}</span>
     </template>
     <template v-slot:[`item.price`]="{ item }">
      <span style="float: left; ">Rp.</span><span style="float:right;">{{
                formatPrice(item.pkb_spare_part_price * item.pkb_spare_part_qty)
              }}</span>
     </template>
     <template  v-slot:expanded-item="{ headers, item }">
      <td class="pa-5" :colspan="headers.length">
      Detail:
      <md-table class="ma-5">
                        <md-table-row >
                            <md-table-head style="text-align: center;"><b>Nota Part No.</b></md-table-head>
                            <md-table-head style="text-align: center;"><b>Date Service</b></md-table-head>
                            <md-table-head style="text-align: center;"><b>Qty</b></md-table-head>
                            <md-table-head style="text-align: center;"><b>Price</b></md-table-head>
                            <md-table-head style="text-align: center;"><b>Total Price</b></md-table-head>
                            
                        </md-table-row>
                         <md-table-row  v-for="(items, index)  in item.spare_part_reff" :key="index">
                                <md-table-cell style="text-align: center;">
                                  <router-link :to="{name: 'Detail Nota Part', params: { id: items.nota_part_id }}" class="btn btn-primary">{{items.nota_part_no}}
                                  </router-link></md-table-cell>
                                <md-table-cell style="text-align: center;">{{items.pkb_datetime}}</md-table-cell>
                                <md-table-cell style="text-align: center;">{{items.pkb_spare_part_qty}}</md-table-cell>
                                <md-table-cell style="text-align: center;">
                                   <span style="float: left; ">Rp.</span><span style="float:right;">{{
                                    formatPrice(items.pkb_spare_part_price)
                                  }}</span>
                                  </md-table-cell>
                                <md-table-cell style="text-align: center;">
                                   <span style="float: left; ">Rp.</span><span style="float:right;">{{
                                    formatPrice(items.pkb_spare_part_price * items.pkb_spare_part_qty)
                                  }}</span>
                                  </md-table-cell>
                         </md-table-row>
                    </md-table>
      </td>
    </template>
    <!-- <template slot="body.append">
      <tr>
          <th style="text-align: center;" colspan="8">TOTAL</th>
          <th> <span style="float: left; ">Rp.</span><span style="float:right;">{{
                formatPrice(total_price)
              }}</span></th>
      </tr>
</template> -->
    </v-data-table>
  </v-card>
    </template>
  </resizable-page>
  </v-app>
</div>
</template>

<script>
import vuetify from '@/plugins/vuetify'
import Swal from "sweetalert2";
import JsonExcel from "vue-json-excel";
import { ResizablePage } from "@/components";

  export default {
    components: {
    downloadExcel: JsonExcel,ResizablePage
  },
    vuetify,
    data () {
      return {
        active_header:false,
        vehicle_chassis_no: null,
        vehicle_door_no: null,
        vehicle_plate_no: null,
        componentKeyMenuRange: 0,
        menu: false,
      menu_range: false,
      modal: false,
        date_list: null,
        date_range_list: null,
        date_list_show: null,
        date_range_list_show: null,
        mounted:true,
        loadTable: false,
        page: 1,
        options: {},
        totalDataTable: 0,
        numberOfPages: 0,
        searchValue:null,
        searchCategory:null,
        option_filter: [ 
          { text: 'Part/Material Category', value: 'spare_part_master_caetgory' },
          { text: 'Part/Material Code', value: 'spare_part_master_code'},
          { text: 'Part/Material Name', value: 'spare_part_master_name'}
          ],
         optionFilterType: [ 
          { text: 'All', value: 0 },
          { text: 'Spare Part', value: 1 },
          { text: 'Material', value: 2}
            ],
          valueFilterType: 0,
         optionFilterCategory: [ 
          { text: 'All', value: 0 },
          { text: 'Fast Moving', value: 1 },
          { text: 'Slow Moving', value: 2}
            ],
          valueFilterCategory: 0,
        role: "",
        search: '',
         headers: [
          {
            text: 'Spare Part Code',
            align: 'center',
            value: 'spare_part_master_code',
          },
          { text: 'Spare Part Name', value: 'spare_part_master_name'  , align: 'center'},
          { text: 'Total Replacement', value: 'spare_part_qty' , align: 'center'},
          { text: 'Detail', value: 'data-table-expand' , align: 'center'},
        ],
        // headers: [
        //   {
        //     text: 'Plat No.',
        //     align: 'center',
        //     value: 'vehicle_plate_no',
        //   },
        //   { text: 'Vehicle No.', value: 'vehicle_door_no'  , align: 'center'},
        //   { text: 'Client Name', value: 'client_name' },
        //   { text: 'Date Service', value: 'pkb_datetime'  , align: 'center'},
        //   { text: 'Nota No.', value: 'nota_part_no' , align: 'center'},
        //   { text: 'Spare Part Code/Name', value: 'spare_part_master_code_name'},
        //   { text: 'Qty', value: 'pkb_spare_part_qty', align: 'center' },
        //   { text: 'Price', value: 'pkb_spare_part_price', align: 'center' },
        //   { text: 'Total Price', value: 'price', align: 'center' },
        // ],
        table: [],
        worksheetName: "Audit usage Sparepart vehicle",
        fileName:"Audit usage Sparepart vehicle.xls",
        exportDisplayedPage:[],
        exportAllFitered:[],
        field_export: {
         'no': 'no',
                          'spare_part_master_code' : 'spare_part_master_code',
                          'spare_part_master_name' : 'spare_part_master_name',
                          'spare_part_replacement_qty' : 'spare_part_replacement_qty',
                          'no_item':  'no_item' ,
                          'nota_part_no': 'nota_part_no',
                          'date_service':  'date_service' ,
                          'qty': 'qty',
                          'price': 'price',
                          'total_price': 'total_price'
        },
      }
    },


    watch:{
    date_range_list: function(nv, ov) {
      console.log(nv)
      if(nv){
        this.date_range_list_show = nv.join(' ~ ')
      }
      else{
        this.date_range_list_show = ""
      }
    },
    deep: true,
  },
    async mounted() {
      //get list role dan permission current user 
      this.role = await this.$store.getters["role_permission/route_filter"];
    //this.getList();
    if(this.$route.query.vehicle_plat_no){
        this.vehicle_plate_no = this.$route.query.vehicle_plat_no
      this.findVehiclePlatNo()
    }
    if(this.$route.query.vehicle_chassis_no){
        this.vehicle_chassis_no = this.$route.query.vehicle_chassis_no
      this.findVehicleChassisNo()
    }
    if(this.$route.query.vehicle_door_no){
        this.vehicle_door_no = this.$route.query.vehicle_door_no
      this.findVehicleDoorNo()
    }


    this.mounted = false
    },
     methods: {
       // ambil data yang dibutuhkan
    async getList() {
     
      // if(this.date_range_list == null){
      //   return
      // }
      this.loadTable= true
      
      var query = {}
      var item_query = {}
      
      if(this.date_range_list !== null){
        if(this.date_range_list[1]){
          item_query.date_to = this.date_range_list[1]
        }
        if(this.date_range_list[0]){
          item_query.date_from = this.date_range_list[0]
        }
      }
      item_query.vehicle_plate_no = this.vehicle_plate_no
     query.filter = {audit_vehicle:JSON.stringify(item_query)}
  
     
      await this.$store.dispatch("workshop_spare_part_master/list",query);
      // if (
      //   (await this.$store.getters["role/list"]) &&
      //   (await this.$store.getters["role/list"].length) != 0
      // ) { 


       this.table = await this.$store.getters["workshop_spare_part_master/list"];
        // const merger = data.map(item => item.item);
        //  this.table =[].concat.apply([], merger)
        // console.log(this.table)
        // this.total_price= 0
        // for (const element of this.table) {
        //     this.total_price = this.total_price + (element.pkb_spare_part_qty * element.pkb_spare_part_price)
        // }
      // }
      // else{
      //   this.table = []
      // }

      this.worksheetName= "Audit usage Sparepart vehicle "+ this.vehicle_plate_no+" "+ this.date_range_list_show
        this.fileName="Audit usage Sparepart vehicle "+ this.vehicle_plate_no+" "+ this.date_range_list_show +".xls"
      this.active_header = true
      this.loadTable= false
    },

    changeDateRange(){
      this.getList()
      
        this.worksheetName= "Audit usage Sparepart vehicle "+ this.vehicle_plate_no+" "+ this.date_range_list_show
        this.fileName="Audit usage Sparepart vehicle "+ this.vehicle_plate_no+" "+ this.date_range_list_show +".xls"
    },

    clear_date_range() {
       this.componentKeyMenuRange += 1;
       this.date_range_list=null
       this.date_range_list_show=null
    },
      // format merubah angka ke currency 
    formatPrice(value) {
        let val = (value/1).toFixed().replace('.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },

    // searchButton(){
    //   this.searchValue = this.search
    //   this.getList()
    // },

    async findVehicleDoorNo(){
      var query = {}
      query.filter = {find_vehicle_door_no:this.vehicle_door_no}
       await this.$store.dispatch("workshop_vehicle/list",query);
       var data = await this.$store.getters["workshop_vehicle/list"];
       if(Object.keys(data).length!=0){
            this.vehicle_chassis_no = data[0].vehicle_chassis_no
            this.vehicle_plate_no = data[0].vehicle_plate_no
            this.vehicle_door_no_no = data[0].vehicle_door_no_no
            this.getList()
       }
       else{
         this.swalFindError()
        
         
       }
    },
    async findVehiclePlatNo(){
      var query = {}
      query.filter = {find_vehicle_plate_no:this.vehicle_plate_no}
       await this.$store.dispatch("workshop_vehicle/list",query);
       var data = await this.$store.getters["workshop_vehicle/list"];
       if(Object.keys(data).length!=0){
            this.vehicle_chassis_no = data[0].vehicle_chassis_no
            this.vehicle_plate_no = data[0].vehicle_plate_no
            this.vehicle_door_no_no = data[0].vehicle_door_no_no
            this.getList()
       }
       else{
         this.swalFindError()
       }
    },

    async findVehicleChassisNo(){
      var query = {}
      query.filter = {find_vehicle_plate_no:this.vehicle_plate_no}
       await this.$store.dispatch("workshop_vehicle/list",query);
       var data = await this.$store.getters["workshop_vehicle/list"];
       if(Object.keys(data).length!=0){
          // this.setData(data[0])
            this.vehicle_chassis_no = data[0].vehicle_chassis_no
            this.vehicle_plate_no = data[0].vehicle_plate_no
            this.vehicle_door_no_no = data[0].vehicle_door_no_no
           this.getList()
       }
       else{
         this.swalFindError()
       }
    },

    swalFindError(){
       this.table = []
         this.vehicle_chassis_no = null
         this.vehicle_plate_no = null
         this.vehicle_door_no_no = null
         this.active_header = true
      Swal.fire({
          icon: 'error',
          title: 'Not Found',
          text: 'Data kendaraan tidak ditemukan',
        })
    },



    // clearSearchButton(){
    //   this.searchValue = null
    //   this.search = null
    //   this.searchCategory = null
    //   this.getList()
    // },

    getFiltered(data){
    this.exportDisplayedPage = this.dataExport(data)
    if(this.$refs.vTable){
      this.exportAllFitered = this.dataExport(this.$refs.vTable.$children[0].filteredItems)
    }
    else{
      this.exportAllFitered = this.dataExport(this.table)
    }
    },

    

    //fungsi untuk mengubah data yang siap di export data ke xls, saat dipanggil di awal dan dipanggil berulang kali di fungsi filter
      dataExport(data){
      //return data.map((v,index) => ({...v, no: index+1}))
      var dataReturn=[]
        data.forEach((value_1, index_1) => {
          
          
              if(value_1.spare_part_reff.length!=0 ){

              
              for (let i = 0;  i < value_1.spare_part_reff.length; i++) {
                   var data= {
                          no:  dataReturn[index_1] && dataReturn[index_1].no == index_1+1 ? null : index_1+1,
                          spare_part_master_code : value_1.spare_part_master_code,
                          spare_part_master_name : value_1.spare_part_master_name,
                          spare_part_replacement_qty : value_1.spare_part_qty,
                          no_item:  i+1 ,
                          nota_part_no: value_1.spare_part_reff[i].nota_part_no,
                          date_service:  value_1.spare_part_reff[i].pkb_datetime ,
                          qty: value_1.spare_part_reff[i].pkb_spare_part_qty,
                          price: value_1.spare_part_reff[i].pkb_spare_part_price,
                          total_price: value_1.spare_part_reff[i].pkb_spare_part_price * value_1.spare_part_reff[i].pkb_spare_part_price,

                        }
                    

                  
                      dataReturn.push(data)
                    } 
                }
              
                

        });
       return dataReturn
      
     
      }
     },
  }
</script>
<style>
.v-application--wrap {
  min-height: unset;
}
.v-list-item__title {
    font-size: 0.8rem;
}
</style>